module.exports = __webpack_public_path__ + "img/1568032803.3c4e2e07.jpg";